import * as React from "react";
const SvgFiRrTired = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-tired_svg__a)">
      <path
        fill="#062147"
        d="M16.789 17.976a15.4 15.4 0 0 0-4.79-.976 15.4 15.4 0 0 0-4.792.976 1 1 0 0 1-1.052-1.518A6.84 6.84 0 0 1 11.999 13a6.83 6.83 0 0 1 5.842 3.458 1 1 0 0 1-1.053 1.518M23.999 12A12.013 12.013 0 0 0 12 0C-3.9.6-3.892 23.4 12 24a12.013 12.013 0 0 0 12-12m-2 0a10.01 10.01 0 0 1-10 10C-1.248 21.5-1.244 2.5 12 2a10.01 10.01 0 0 1 10 10m-4.167-.445a1 1 0 0 0-.277-1.387L15.8 9l1.752-1.168a1 1 0 1 0-1.11-1.664l-3 2a1.007 1.007 0 0 0 0 1.664l3 2a1 1 0 0 0 1.386-.277zm-10.277.277 3-2a1.007 1.007 0 0 0 0-1.664l-3-2a1 1 0 0 0-1.11 1.664L8.2 9l-1.755 1.168a1 1 0 0 0 1.11 1.664"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-tired_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrTired;
